import { HttpError } from "@calcom/lib/http-error";

export class AiAssistantSsoService {
  async getRedirectUrl(): Promise<string> {
    const response = await fetch("/api/ai-assistant/sso");

    if (!response.ok) {
      throw new HttpError({
        statusCode: response.status,
        message: "Failed to get AI Assistant redirect URL",
      });
    }

    const data = await response.json();
    return data.redirectUrl;
  }
}
